var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundSpaceDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 21H9C10.1 21 11 20.1 11 19V5C11 3.9 10.1 3 9 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21ZM21 5V8C21 9.1 20.1 10 19 10H15C13.9 10 13 9.1 13 8V5C13 3.9 13.9 3 15 3H19C20.1 3 21 3.9 21 5Z",
    fill: "#9E3039"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21H19C20.1 21 21 20.1 21 19V14C21 12.9 20.1 12 19 12H15C13.9 12 13 12.9 13 14V19C13 20.1 13.9 21 15 21Z",
    fill: "#9E3039"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundSpaceDashboardActive);
export default __webpack_public_path__ + "static/media/ic_round-space-dashboard-active.0dafd510ef5d9340804a43611791457e.svg";
export { ForwardRef as ReactComponent };